const fullAddress = data => {
  try {
    if (data) {
      const splited = data.street.split(' - ');
      const str = `${splited[0]}, ${data.number} - ${splited[1]} - ${
        data.zipCode
      }`;
      return str;
    } else {
      return '---';
    }
  } catch (err) {
    console.error(err);
    return '---';
  }
};

export default fullAddress;
